"use strict";

import "select2";
import React, { Component, PropTypes } from "react";

import InputComponentBase from ".\\InputComponentBase";

import "select2/dist/css/select2.css";

/******************************************************************************
** CountrySelectInput
*/

export default class CountrySelectInput extends InputComponentBase {

	static get DefaultCountries() {
		return [
				{ id: "gb", text: "United Kingdom" },
				{ id: "ru", text: "Russia" }
			];
	}

	constructor(props) {
		super(props);
		let defaultCountryIso2Code = props.defaultValue || props.context.getFormState().currentCountryIso2Code.toLowerCase();
		this.state = Object.assign(this.state || {}, {
			countries: CountrySelectInput.DefaultCountries,
			value: defaultCountryIso2Code
		});
		this._onSelectChange = this._onSelectChange.bind(this);
	}

	componentWillMount() {
		if (typeof super.componentWillMount == "function")
			super.componentWillMount();

		let self = this;

		const url = "/umbraco/Surface/CountrySurface/GetCountries";
		this.props.context.form.getData(url, function(data) {
			//console.info(data);
			let countries = data.countries.map(function(i) { return { id: i.Iso2Code, text: i.Name }; });
			self.setState({
				countries: countries,
				value: data.defaultCountryIso2Code
			});
		});
	}

	componentDidMount() {
		if (typeof super.componentDidMount == "function")
			super.componentDidMount();

		let formatItem = function (item) {
			if (!item.id) { return item.text; }
			let $item = $('<span><div class="flag-icon flag-icon_' + item.id + '"></div>' + item.text + "</span>");
			return $item;
		};
		const $select = $(this._getUserInput());
		$select.select2({
			width: "off",
			placeholder: this.props.title,
			templateResult: formatItem,
			templateSelection: formatItem
		});
	}

	componentWillUpdate() {
		if (typeof super.componentWillUpdate == "function")
			super.componentWillUpdate();
		const $select = $(this._getUserInput());
		$select.off("change", this._onSelectChange);
	}

	componentDidUpdate() {
		if (typeof super.componentDidUpdate == "function")
			super.componentDidUpdate();
		const $select = $(this._getUserInput());

		const currentValue = $select.val();
		if (typeof this.state.value != "undefined") {
			if (currentValue !== this.state.value) {
				this.selectValue(this.state.value);
			}
		} else {
			this.selectValue(currentValue);
		}

		$select.on("change", this._onSelectChange);
	}

	_onSelectChange(event) {
		const selectedValue = $(event.target).val();
		this.selectValue(selectedValue);
	}

	selectValue(selectedValue) {
		const $select = $(this._getUserInput());

		//console.log($select.val(), selectedValue);
		if ($select.val() !== selectedValue) {
			$select.val(selectedValue);
		}

		this.setState({ value: selectedValue });
		this.props.context.dispatcher.dispatch({
			actionType: "country-update",
			selectedCountry: selectedValue
		});
	}

	render() {
		let label = null;
		if (this.props.showLabel) {
			label = this.renderLabel(this.props.title);
		}
		let placeholder = null;
		if (this.props.showPlaceholder) {
			placeholder = this.props.title;
		}
		return (
				<div className={this.props.containerClassNames} ref="topContainer">
					<div className={this.props.inputClassNames}>
						{label}
						{this.renderEditor(placeholder)}
					</div>
				</div>
			);
	}

	renderLabel(labelText) {
		return (<label className="input-select__label">{labelText}</label>);
	}

	renderEditor(placeholderText) {
		let items = this.state.countries.map(function(item){
			return (<option key={item.id} value={item.id}>{item.text}</option>);
		});
		return (
				<select ref="input" className="input-select__input" id={this.state.clientId} name={this.state.inputName} defaultValue={this.state.value}>
					{items}
				</select>
			);
	}

}



/** WEBPACK FOOTER **
 ** ./forms/CountrySelectInput.jsx
 **/